import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { SectionTitle } from '../../components/TypographyStyles';
import { maskSensitiveInfo } from '../../utils/stringUtils';
import { authService } from '../../services/auth.service';
import { useNavigate } from 'react-router-dom';
import { RouteDefine } from '../../routes/index.tsx/RouteDefine';

const ConnectionInfo: React.FC = () => {
  const navigate = useNavigate();
  const connectionData = authService.getConnectionData();
  
  console.log('Connection Data:', connectionData);

  const handleDisconnect = () => {
    authService.disconnect();
    navigate(`/${RouteDefine.setupConnection}`);
  };

  if (!connectionData) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="body1" color="text.secondary">
          No connection data available. Please set up your connection first.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', md: 'row' },
        gap: 3,
        mb: 3
      }}>
        <Paper elevation={3} sx={{ p: 3, flex: 1 }}>
          <SectionTitle>Dinero</SectionTitle>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box>
              <Typography variant="body2" color="text.secondary">Client ID:</Typography>
              <Typography variant="body1" fontFamily="monospace">{maskSensitiveInfo(connectionData.dinero.clientId)}</Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">Client Secret:</Typography>
              <Typography variant="body1" fontFamily="monospace">{maskSensitiveInfo(connectionData.dinero.clientSecret)}</Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">API Key:</Typography>
              <Typography variant="body1" fontFamily="monospace">{maskSensitiveInfo(connectionData.dinero.apiKey)}</Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">Organization ID:</Typography>
              <Typography variant="body1" fontFamily="monospace">{maskSensitiveInfo(connectionData.dinero.organizationId)}</Typography>
            </Box>
          </Box>
        </Paper>

        <Paper elevation={3} sx={{ p: 3, flex: 1 }}>
          <SectionTitle>e-conomic</SectionTitle>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box>
              <Typography variant="body2" color="text.secondary">Token:</Typography>
              <Typography variant="body1" fontFamily="monospace">{maskSensitiveInfo(connectionData.economic.token)}</Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">Name:</Typography>
              <Typography variant="body1">{connectionData.economic.name}</Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">Number:</Typography>
              <Typography variant="body1">{connectionData.economic.number}</Typography>
            </Box>
          </Box>
        </Paper>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button 
          variant="outlined" 
          color="error" 
          onClick={handleDisconnect}
          sx={{ mt: 2 }}
        >
          Disconnect
        </Button>
      </Box>
    </Box>
  );
};

export default ConnectionInfo;
